// extracted by mini-css-extract-plugin
module.exports = {"root":"DigitInput_root__3yN5K","license":"DigitInput_license__PnPZO"};